import { render, staticRenderFns } from "./PersonCreateBulk.view.vue?vue&type=template&id=709b508c"
import script from "./PersonCreateBulk.view.vue?vue&type=script&lang=js"
export * from "./PersonCreateBulk.view.vue?vue&type=script&lang=js"
import style0 from "./PersonCreateBulk.view.vue?vue&type=style&index=0&id=709b508c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports